module.exports = __webpack_public_path__ + "6670ee5c791dc6bd96744b0ca33633a9.webp";